import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography, IconButton, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { ReactComponent as CloseIcon } from "../../../icons/Close.svg";
import { Trash } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },

  titleContainer: {
    marginBlock: "auto",
    textAlign: "center",
  },

  title: {
    fontWeight: "bold",
    color: theme.palette.common.black,
  },

  close: {
    marginLeft: theme.spacing(-1.5),
  },

  actions: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
}));

export interface NutritionHeaderProps extends BoxProps {
  onClose: () => void;
  onDelete?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  title?: string;
}

export function NutritionHeader(props: NutritionHeaderProps) {
  const {
    className,
    title,
    onClose,
    onDelete,
    disabled = false,
    ...other
  } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <IconButton
        className={s.close}
        color="primary"
        children={<CloseIcon />}
        onClick={onClose}
        disabled={disabled}
        size="large"
      />

      <Box className={s.actions}>
        <Box className={s.titleContainer}>
          <Typography className={s.title} variant="h4" children={title} />
        </Box>
        {onDelete && (
          <Tooltip title="Remove target" placement="top" arrow>
            <IconButton
              className={s.close}
              color="primary"
              children={<Trash />}
              onClick={onDelete}
              disabled={disabled}
              size="large"
            />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}
